import React, { useMemo } from "react";
import { NativeInvoiceFormContext } from "./NativeInvoiceFormContext";
import { NativeInvoiceFormState } from "./nativeInvoiceFormTypes";

interface Props {
    state: NativeInvoiceFormState;
    setState: React.Dispatch<React.SetStateAction<NativeInvoiceFormState>>;
    children: React.ReactNode;
}

export const NativeInvoiceFormProvider: React.FC<Props> = ({
    state,
    setState,
    children,
}) => {
    const value = useMemo(() => ({ state, setState }), [state, setState]);

    return (
        <NativeInvoiceFormContext.Provider value={value}>
            {children}
        </NativeInvoiceFormContext.Provider>
    );
};
